import { Loading } from "element-ui";
// import Vue from "vue";

class LoadingService {
  constructor() {
    this.loadingInstance = null;
    this.loadingCount = 0;
    this.loadingText = "加载中...";
  }

  /**
   * 显示loading
   * @param {string} text - loading提示文本
   */
  show(text = "加载中...") {
    this.loadingCount++;
    this.loadingText = text;

    // 如果已经有loading实例，只更新文本
    if (this.loadingInstance) {
      this.loadingInstance.text = text;
      return;
    }

    // 创建新的loading实例
    this.loadingInstance = Loading.service({
      lock: true,
      text: this.loadingText,
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }

  /**
   * 更新loading文本
   * @param {string} text - 新的loading提示文本
   */
  updateText(text) {
    if (this.loadingInstance) {
      this.loadingInstance.text = text;
      this.loadingText = text;
    }
  }

  /**
   * 关闭loading
   */
  close() {
    this.loadingCount--;
    if (this.loadingCount <= 0) {
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
      this.loadingCount = 0;
    }
  }
}

// 创建单例
const loadingService = new LoadingService();

// // 注册到Vue原型上
// Vue.prototype.$loading = loadingService;

export default loadingService;



// WEBPACK FOOTER //
// ./src/util/loadingService.js